import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { useTranslation } from 'react-i18next';

const RenderTable = props => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [rowSelection, setRowSelection] = useState(null);
  const [onClick, setOnClick] = useState(null);
  const [pagination, setPagination] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    props.data && setData(props.data);
    props.columns && setColumns(props.columns);
    props.rowSelection && setRowSelection(props.rowSelection);
    props.onClick && setOnClick(props.onClick);
    props.pagination && setPagination(props.pagination);
  }, [props]);

  return (
    <Table
      bordered
      dataSource={data}
      columns={columns}
      rowSelection={rowSelection}
      pagination={pagination}
      bodyStyle={{ backgroundColor: "White" }}
      onRow={element => ({
        onClick: e => (onClick === undefined || onClick === null ? e.preventDefault() : onClick(element))
      })}
      locale={{
        filterConfirm: t('button.filter.ok'),
        filterReset: t('button.filter.reset'),
        emptyText: t('table.body.is_empty')
      }}
    />
  );
};

export default RenderTable;
